exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".resize-detector[data-v-eddf4c26],.resize-detector[data-v-eddf4c26] object{display:block;position:absolute;top:0;left:0;height:100%;width:100%;border:none;padding:0;margin:0;opacity:0;pointer-events:none;z-index:-1000;background:transparent}", ""]);

// exports
